import { NgModule } from '@angular/core';
import { PublisherDashboardComponent } from "./publisher-dashboard.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../../shared/shared.module";
import { Ng2DatetimePickerModule } from "ng2-datetime-picker/dist";
import { DashboardSharedModule } from "../dashboard-shared.module";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        Ng2DatetimePickerModule,
        DashboardSharedModule
    ],
    exports: [],
    declarations: [PublisherDashboardComponent],
    providers: [],
})
export class PublisherDashboardModule { }



// WEBPACK FOOTER //
// ./src/app/dashboard/publisher-dashboard/publisher-dashboard.module.ts